module.exports = __webpack_public_path__ + "static/media/webvision1.1b88f3e8.png";